import academia from './endpoints/academia'
import autoresponder from './endpoints/autoresponder'
import axios from 'axios'
import cliente from './endpoints/cliente'
import comprobante from './endpoints/comprobante'
import configApp from '@/config'
import contenido from './endpoints/contenido'
import divisa from './endpoints/divisa'
import inscripcion from './endpoints/inscripcion'
import parametro from './endpoints/parametro'
import pasarela from './endpoints/pasarela'
import producto from './endpoints/producto'
import proyecto from './endpoints/proyecto'
import puntoVenta from './endpoints/punto-de-venta'
import usuario from './endpoints/usuario'
import ventas from './endpoints/ventas'
import Vue from 'vue'

let services = new Vue({
  data () {
    return {
      apiUrl: `${configApp.apiUrl}/${configApp.apiVersion}`,

      entities: {
        academia,
        autoresponder,
        cliente,
        comprobante,
        contenido,
        divisa,
        inscripcion,
        parametro,
        pasarela,
        producto,
        proyecto,
        puntoVenta,
        usuario,
        ventas
      }
    }
  },

  methods: {
    convert (entity, endpoint, params) {
      endpoint = `${this.entities[entity][endpoint]}`
      if (params.length > 0) {
        endpoint = endpoint.split('/')
        params.forEach(param => {
          let index = endpoint.findIndex(endp => endp.includes('{'))
          if (index !== -1) {
            endpoint[index] = param.toString()
          }
        })
        endpoint = endpoint.join('/')
      }
      return endpoint
    },

    create (entity, endpoint, data = {}, params = []) {
      endpoint = this.convert(entity, endpoint, params)
      return axios.post(`${this.apiUrl}/${endpoint}`, data)
    },

    delete (entity, endpoint, data = {}, params = []) {
      endpoint = this.convert(entity, endpoint, params)
      return axios.delete(`${this.apiUrl}/${endpoint}`, data)
    },

    read (entity, endpoint, data = {}, params = [], filter = {}) {
      endpoint = this.convert(entity, endpoint, params)
      if (Object.keys(filter).length > 0) {
        let query = []
        Object.entries(filter).forEach(([key, value]) => {
          if (value || value.length !== 0 || value === 0 || value === false) {
            if (Array.isArray(value)) {
              value.forEach(subValue => {
                query.push(`${key}[]=${subValue}`)
              })
            } else {
              query.push(`${key}=${value}`)
            }
          }
        })
        endpoint = `${endpoint}?${query.join('&')}`
      }
      return axios.get(`${this.apiUrl}/${endpoint}`, data)
    },

    update (entity, endpoint, data = {}, params = []) {
      endpoint = this.convert(entity, endpoint, params)
      return axios.put(`${this.apiUrl}/${endpoint}`, data)
    }
  }
})

axios.interceptors.request.use((config) => {
  const frontendDomain = configApp.appDomain
  if (frontendDomain) {
    config.headers['X-Frontend-Domain'] = frontendDomain
  }
  return config
})

export default {
  install: (Vue) => {
    Vue.prototype.$services = services
  }
}
